"use client";

import { HTML5Backend } from "react-dnd-html5-backend";
import dynamic from "next/dynamic";
import { PropsWithChildren } from "react";
import { useStores } from "../../stores/useStores";

// Sibling providers must share one manager. react-dnd's default global singleton is
// cleared when its refCount hits 0 (e.g. strict mode remounts), and a second manager
// throws "Cannot have two HTML5 backends at the same time".
const DndProvider = dynamic(() =>
  import("react-dnd").then(({ DndProvider, createDndContext }) => {
    const { dragDropManager } = createDndContext(HTML5Backend);
    return (props: PropsWithChildren<{}>) => (
      // @ts-ignore
      <DndProvider manager={dragDropManager}>{props.children}</DndProvider>
    );
  }),
);

export function DragAndDropProvider(props: PropsWithChildren<{}>) {
  const { userStore } = useStores();

  if (userStore.editor) {
    return <DndProvider>{props.children}</DndProvider>;
  } else {
    return props.children;
  }
}
